import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { DiscountBadgeShape } from '../../enums';
import styles from './DiscountBadge.module.scss';
const DiscountBadge = ({ className, isBig, percentage, primaryColor, secondaryColor, shape, text, textColor, withHint, }) => {
    const isCircleShape = shape === DiscountBadgeShape.Circle;
    const isPillShape = shape === DiscountBadgeShape.Pill;
    return (_jsxs("div", { className: classnames(styles[shape], {
            'flex-column justify-content-center': isCircleShape,
            'd-flex align-items-center p-1x px-xs-2x': !isPillShape,
            'd-inline-block py-0-5x px-1-5x px-xs-2x': isPillShape,
            'py-1x pl-2x pr-3x pr-xs-3x': !isCircleShape && !isPillShape && isBig,
            'p-1x px-xs-2x pr-xs-3x': !isCircleShape && !isPillShape && !isBig,
            [styles.isBig]: isBig,
        }, className), style: {
            color: textColor,
            '--primaryColor': primaryColor,
            '--secondaryColor': secondaryColor || primaryColor,
        }, children: [_jsxs("div", { className: classnames({
                    'mb-1x': isCircleShape && !!percentage && !!text?.trim(),
                    'd-inline-block': isPillShape,
                }), children: [percentage && _jsxs("span", { className: styles.percentage, children: ["-", percentage, "%"] }), percentage && withHint && _jsx("span", { className: styles.hint, children: "*" })] }), text?.trim() && _jsx("span", { className: styles.textContent, children: text })] }));
};
export { DiscountBadge };
